export function accordion() {
    let accordionClassName = "accordion";
    let accordionSelector = "." + accordionClassName;
    let initClassName = accordionClassName + "-initialize";

    let closeItems = function (context) {
        let accordionContainer = context.closest(accordionSelector);
        let accordionItems = accordionContainer.find("li");

        accordionItems.map((index, item) => {
            let accordionItem = $(item);

            accordionItem.removeClass("active");
            accordionItem.find(".hidden").slideUp();
        });
    };

    let initAccordion = function () {
        let accordions = $(accordionSelector);

        accordions.not("." + initClassName).each(function () {

            $(this)
                .addClass(initClassName)
                .on("click", "h5", function () {
                    let item = $(this).closest("li");

                    if (!item.hasClass("active")) {
                        closeItems($(this));
                        item.addClass("active").find(".hidden").slideDown();
                    } else {
                        item.toggleClass("active").find(".hidden").slideToggle();
                    }
                }).find("li:first h5").trigger("click");
        });
    };

    initAccordion();
};


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js